import { useQuery, UseQueryOptions } from 'react-query';
import { useService } from '@core/inversify-react';

import { GetDiscountStatsRepoType, IGetDiscountStatsRepo } from '../repos';
import { DiscountStat } from '../interfaces';

export const useGetDiscountStats = (id?: string, queryOptions?: UseQueryOptions<DiscountStat[], Error, DiscountStat[], string[]>) => {
  const getDiscountStatsRepo = useService<IGetDiscountStatsRepo>(GetDiscountStatsRepoType);

  return useQuery<DiscountStat[], Error, DiscountStat[], any[]>(
    ['users', id],
    async ({ queryKey }) => {
      const [, id] = queryKey;
      const result = await getDiscountStatsRepo.execute(id);

      if (result.status === 200) {
        return result.response;
      } else {
        throw new Error(result.response);
      }
    },
    queryOptions,
  );
};
